/**
 * Bearer-token persistence. The login response carries an access token which we
 * store here and attach to every request (see lib/api interceptors). The backend
 * also sets an httpOnly cookie for same-origin use; the header path is what makes
 * the dev server (cross-origin) work too.
 *
 * localStorage is an accepted XSS trade-off for an internal ops tool; token
 * hardening is a Phase-16 concern.
 */
const KEY = "boond.auth.token";

export function getToken(): string | null {
  try {
    return localStorage.getItem(KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(KEY, token);
  } catch {
    /* storage unavailable (private mode) — cookie fallback still applies */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** Fired when the API returns 401 so the auth layer can drop to the login view. */
export const UNAUTHORIZED_EVENT = "boond:unauthorized";
